import { LOCALE_EN, LOCALE_RU } from '../constant';
import { PRODUCT_URL, getFetchRequest } from '../store/requests';
import {
    buildCsv,
    downloadCsvFile,
    formatFormLinks,
    formatPropertyForms,
    formatPropertyValue,
    formatPropertyReferenceBook,
    getLocalizedName,
} from './csvExportUtils';
import { errorCallback, makeUrl } from '../util';

const PRODUCTS_EXPORT_QUERY = '?withDeleted=true&withStatus=true&withForms=true&withProperties=true&withImages=true';

const PRODUCT_CSV_HEADERS = [
    'productId',
    'productCode',
    'productCategory',
    'basedOnCode',
    'beforeCookingRinseNeed',
    'isDeleted',
    'dateCreated',
    'nameRu',
    'nameEn',
    'productForms',
    'propertyId',
    'propertyName',
    'propertyCategory',
    'propertyType',
    'numberUnits',
    'propertyValue',
    'propertyMinValue',
    'propertyMaxValue',
    'propertyForms',
    'propertyReferenceBook',
];

const getProductProperties = (product) => {
    if (!product.properties) {
        return [];
    }
    if (Array.isArray(product.properties)) {
        return product.properties;
    }
    return Object.values(product.properties);
};

const mapProductBaseFields = (product) => ([
    product.id || '',
    product.productCode || '',
    product.productCategory || '',
    product.basedOnCode || '',
    product.beforeCookingRinseNeed === true ? 'true' : 'false',
    product.isDeleted === true ? 'true' : 'false',
    product.dateCreated || '',
    getLocalizedName(product.names, LOCALE_RU),
    getLocalizedName(product.names, LOCALE_EN),
    formatFormLinks(product.productForms),
]);

const mapProductPropertyRow = (product, property) => [
    ...mapProductBaseFields(product),
    property.id || '',
    property.propertyName || '',
    property.categoryName || '',
    property.propertyType || '',
    property.numberUnits || '',
    formatPropertyValue(property.value),
    property.minValue ?? '',
    property.maxValue ?? '',
    formatPropertyForms(property.productForms),
    formatPropertyReferenceBook(property),
];

export const exportProductsToCsv = (onComplete) => {
    getFetchRequest(
        makeUrl([PRODUCT_URL, PRODUCTS_EXPORT_QUERY]),
        (products) => {
            const rows = [];
            (products || []).forEach((product) => {
                const properties = getProductProperties(product);
                if (properties.length === 0) {
                    rows.push([
                        ...mapProductBaseFields(product),
                        '', '', '', '', '', '', '', '', '', '',
                    ]);
                    return;
                }
                properties.forEach((property) => {
                    rows.push(mapProductPropertyRow(product, property));
                });
            });
            const csv = buildCsv(PRODUCT_CSV_HEADERS, rows);
            downloadCsvFile('products.csv', csv);
            onComplete?.();
        },
        (err) => {
            errorCallback(err);
            onComplete?.();
        },
    );
};
